import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {DataExportBuiltInMappingInfo} from '../../types/DataExport';

interface MappingState {
  defaultMappings: DataExportBuiltInMappingInfo[];
  loading: boolean;
  error: string | null;
}

export const DATA_EXPORT_MAPPINGS_REDUCER = 'dataExportMappingsReducer';

const initialState: MappingState = {
  defaultMappings: [{
    id: '',
    name: '',
    description: '',
    accountId: '',
    mapping: {},
  }],
  loading: false,
  error: null,
};

export const dataExportMappingsSlice = createSlice({
  name: 'dataExportBuiltInMappings',
  initialState,
  reducers: {
    setDefaultMappings: (state, action: PayloadAction<DataExportBuiltInMappingInfo[]>) => {
      state.defaultMappings = action.payload;
    },

    clearError: (state) => {
      state.error = null;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setDefaultMappings,
  clearError,
  setLoading,
  setError,
} = dataExportMappingsSlice.actions;

export default {
  name: DATA_EXPORT_MAPPINGS_REDUCER,
  reducer: dataExportMappingsSlice.reducer,
};
